module.exports = __webpack_public_path__ + "static/media/collaborate-Wed_23.90651fe8.jpg";